import list from 'assets/info.json';
import { ControlContext } from 'provider/ControlProvider';
import { useContext, useEffect, useRef } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import Style from './style.module.scss';

const Popup = () => {
  const { buttonIndex, popupRef } = useContext(ControlContext);
  return (
    <div className={Style.wrapper}>
      <div
        ref={popupRef}
        className={Style.content}
        style={{
          display: buttonIndex > -1 ? 'block' : 'none',
        }}
      >
        <div id='popup' className={Style.button}>
          <div className={Style.title}>
            <p className='text-xl md:text-5xl'>+</p>
            <p id='titleInfo' className='text-center'>
              &nbsp;{list[buttonIndex < 0 ? 0 : buttonIndex].name}
            </p>
          </div>
          <div className={Style.info}>
            <p className='absolute w-8 h-8 border-t-2 border-r-2 right-10 top-6 md:top-12 border-white' />
            <Scrollbars autoHide>
              <div
                id='textInfo'
                className='pb-32'
                dangerouslySetInnerHTML={{
                  __html: list[buttonIndex < 0 ? 0 : buttonIndex].info,
                }}
              />
            </Scrollbars>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Popup;
